/**
 * @module web/store
 * @private
 */

let geolocation = null;

/**
 * Update the user geolocation related data, by storing it in memory.
 * @param {Object} newGeolocationData - An object containing user geolocation data obtained from a request through a backend call.
 * @public
 */
const update = function(newGeolocationData) {
  geolocation = newGeolocationData;
};

/**
 * Returns the current user geolocation related data object stored in memory, where it will be searched for.
 * @returns {Object} - A found stored geolocation related data object or null if not found in memory.
 * @public
 */
const get = function() {
  return geolocation;
};

export default { update, get };
